<!-- original go back to pick -->
<!--<a *ngIf="!dialogMode" mat-button  class="goBack" routerLink="/getstarted/pick">-->
<div class="templates-wrapper">
    <div flashlightText [highlighted]="true" [activeForSeconds]="2" class="start-text" style="width: 100%; text-align: center; position: relative; top: 20px; display: flex; justify-content: center; align-items: center;">
        <mat-icon style="margin-right: 5px;">star_outline</mat-icon>
        {{ 'account.pickStartWith' | transloco }}
    </div>
    <div class="templates-header">
        <div class="goBackDiv">

            @if (!dialogMode) {
                <a mat-button class="goBack" (click)="goBack()">
                    <mat-icon>keyboard_arrow_left</mat-icon>
                    {{ 'account.back' | transloco }}
                </a>
            }
            <mat-form-field class="filter">
                <mat-label>{{ 'placeholder.searchList' | transloco }}</mat-label>
                <input inputrestriction="basic1" matInput (keyup)="applyFilter($event.target['value'])" placeholder="">
            </mat-form-field>
        </div>
        <div class="templates-label hide-lt-md">
            @if (!dialogMode) {
                <mat-label class="headerLabel"> {{ studioType == 0 ? ('account.templatesLegacy' | transloco) : '' }}</mat-label>
            }
        </div>
        <div class="templates-filter">
            @if (dialogMode) {
                <div style="margin-top: 5px;">
                    <mat-form-field appearance="fill">
                        <mat-label>filter by studio</mat-label>
                        <mat-select [(value)]="selectedStudioType" (selectionChange)="filterByStudio($event)">
                            @for (item of ['Sign Studio', 'Legacy Studio', 'All']; track item) {
                                <mat-option [value]="item">
                                    {{ item }}
                                </mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                </div>
            }
            @if (dataSource && studioType != 0 && !enterprise) {
                <mat-radio-group class="filter-touch" (change)="filterByTouch($event)" [value]="selectedGroup" style="padding-top: 10px">
                    <mat-radio-button [value]="'all'">All</mat-radio-button>
                    <mat-radio-button [value]="'signage'">Signage</mat-radio-button>
                    <mat-radio-button [value]="'touch'">Interactive</mat-radio-button>
                </mat-radio-group>
            }
            @if (!dialogMode) {
                <a matTooltip="{{'account.legacyStudio' | transloco}}" mat-icon-button class="hide-lt-md noDecoration" routerLink="/getstarted/pick" style="opacity: 0.8">
                    <mat-icon>join_inner</mat-icon>
                </a>
            }
        </div>
    </div>
    <div class="templates-body">
        @if (!dataSource || filtering) {
            <app-loading type="-1" [size]="'50px'" class="templates-loading"></app-loading>
        }
        @if (dataSource) {
            <div class="mat-elevation-z8 full-height templates" [ngClass]="{'filtering': filtering}">
                <mat-table [dataSource]="dataSource" matSort>
                    <ng-container matColumnDef="color">
                        <mat-cell *matCellDef="let row" [style.color]="row.color">
                            <img imgFallback class="inverter" [src]="row.icon"/>
                            <!--            <img  class="inverter" width="512" height="387"  priority [ngSrc]="row.icon"/>-->
                        </mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="id">
                        <mat-cell (click)="openDialogPreview($event, row, row.studioType)" class="templateName num" *matCellDef="let row">
                            <div>
                                @switch (row.category) {
                                    @case ('Interactive') {
                                        <div>
                                            <mat-icon class="prevIcon">touch_app</mat-icon>
                                            <br/>
                                            <mat-label style="position: relative; top: 10px; left: 3px" class="prevText">preview</mat-label>
                                        </div>
                                    }
                                    @case ('Playlist') {
                                        <div>
                                            <mat-icon class="prevIcon">play_circle_outline</mat-icon>
                                            <br/>
                                            <mat-label class="prevText">preview</mat-label>
                                        </div>
                                    }
                                    @default {
                                        <div>
                                            @if (row.name == 'Empty account') {
                                                <mat-icon (click)="onSelection(row)" class="prevIcon">radio_button_unchecked</mat-icon>
                                            }
                                            @if (row.name !== 'Empty account') {
                                                <mat-icon class="prevIcon">play_circle_outline</mat-icon>
                                            }
                                            <br/>
                                            @if (row.name !== 'Empty account') {
                                                <mat-label class="prevText">preview</mat-label>
                                            }
                                        </div>
                                    }
                                }
                            </div>
                        </mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="name">
                        <mat-cell *matCellDef="let row">
                            <div class="templateName">
                                {{ row.name }}
                                <div class="templateType">
                                    {{ row.studioType === 2 ? 'SignStudio' : 'LegacyStudio' }}
                                </div>
                            </div>
                        </mat-cell>
                    </ng-container>
                    <mat-row (click)="onSelection(row)" *matRowDef="let row; columns: displayedColumns;">
                    </mat-row>
                </mat-table>
            </div>
        }
    </div>
</div>

